import type { IQuestionFormatsEnum } from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import type { IResponseOption } from "@/interfaces";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<IQuestionFormatsEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.questionFormats");

export const questionFormats = {
  ...getAllApis,
};
